import React from 'react';
import UsersList from '../../components/users/UsersList';

export const UsersPage = () => {

    return (
        <UsersList />
    )
}